import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { errorFunction } from "../../../Components/Alert/Alert";

// get ApiLogs
export const checkDocRule = createAsyncThunk("commonApiCall/checkDocRule", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.checkDocRule();

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

export const getChargeStatus = createAsyncThunk("commonApiCall/getChargeStatus", async (type, { rejectWithValue }) => {
  try {
    const { data } = await API.getChargeStatus(type);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
